import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={533.185}
      height={400.85}
      viewBox="0 0 533.185 400.85"
      {...props}
    >
      <g data-name="Asset 3">
        <g data-name="Layer 2">
          <g data-name="Group 466">
            <path
              data-name="Path 9220"
              d="M513.812 288.251a34.731 34.731 0 01-1.414-11.975c1.168-17.933 15.585-31.637 19.195-48.963 3.5-16.893 1.367-36.03-12.045-48.192-18.541-16.8-47.689-14.966-60.891-38.694-11.823-21.251-9.241-46.953-22.127-68.216-12.138-19.989-31.567-33.647-52-44.161C354.937 12.734 320.578-.456 286.908.01c-38.25.549-65.541 26.532-91.126 51.767-22.548 22.2-62.258 20.2-50.692 77.6 10.316 51.112-14.019 47.315-36.275 66.195s-38.495 41.3-29.651 66.791c9.743 28.132-49.956 44.266-60.6 80.705-7.232 24.721 30.7 26.812 56.522 26.812s246.695-2.1 340.111.829c25.761.806 50.47 1.624 76.1-1.519 10.877-1.344 21.975-4.159 30.527-11.005 26.791-21.427-1.318-46.849-8.012-69.934z"
              fill="#c3ecfe"
              opacity={0.35}
            />
          </g>
          <path
            data-name="Path 9221"
            d="M485.853 367.811a89.958 89.958 0 018.54-64.256l.666.374a89.152 89.152 0 00-8.47 63.707z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9222"
            d="M492.011 309.047a16.706 16.706 0 014.5-10.7 3.365 3.365 0 012.488-1.32 1.168 1.168 0 01.713.292 1.4 1.4 0 01.2 1.227 11.367 11.367 0 01-3.6 5.666c-1.636 1.577-2.652 2.979-4.3 4.837"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9223"
            d="M489.055 316.523a16.753 16.753 0 018.377-8.038 3.4 3.4 0 012.8-.234 1.168 1.168 0 01.549.561 1.4 1.4 0 01-.315 1.168 11.227 11.227 0 01-5.549 3.773c-2.126.794-3.61 1.682-5.841 2.734"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9224"
            d="M486.006 326.512a16.683 16.683 0 017.325-9 3.329 3.329 0 012.745-.572 1.028 1.028 0 01.608.491 1.367 1.367 0 01-.152 1.227 11.215 11.215 0 01-5.047 4.416c-2.021 1.063-3.388 2.115-5.479 3.435"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9225"
            d="M484.394 336.583a16.66 16.66 0 017.337-9 3.318 3.318 0 012.745-.572 1.063 1.063 0 01.608.491 1.4 1.4 0 01-.152 1.227 11.181 11.181 0 01-5.059 4.416c-2.009 1.063-3.376 2.115-5.479 3.435"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9226"
            d="M483.973 350.116a16.683 16.683 0 016.355-9.708 3.342 3.342 0 012.675-.853 1.04 1.04 0 01.654.421 1.367 1.367 0 010 1.238 11.2 11.2 0 01-4.556 4.919c-1.893 1.262-3.143 2.453-5.094 3.984"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9227"
            d="M484.615 359.949a17.874 17.874 0 015.549-9.86 3.727 3.727 0 012.5-1.238.888.888 0 01.643.257 1.169 1.169 0 010 1.168 12.594 12.594 0 01-4.089 5.234c-1.729 1.472-2.862 2.769-4.673 4.486"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9228"
            d="M487.91 320.016a18.05 18.05 0 01-5.456-10.865 3.692 3.692 0 01.537-2.921 1.168 1.168 0 01.689-.385 1.367 1.367 0 011.063.666 12.326 12.326 0 012.126 6.741c.2 2.407.643 4.171 1.04 6.764"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9229"
            d="M485.819 327.821a18.073 18.073 0 01-7.9-9.241 3.727 3.727 0 01-.175-2.967 1.075 1.075 0 01.573-.537 1.39 1.39 0 011.168.385 12.419 12.419 0 013.68 6.052c.759 2.278 1.612 3.89 2.629 6.309"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9230"
            d="M484.347 338.206a18.074 18.074 0 01-9.58-7.477 3.739 3.739 0 01-.771-2.874 1.075 1.075 0 01.456-.643 1.379 1.379 0 011.25.14 12.372 12.372 0 014.8 5.187 64.837 64.837 0 003.844 5.666"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9231"
            d="M483.751 351.665a18.027 18.027 0 01-7.687-9.428 3.692 3.692 0 01-.117-2.956 1.087 1.087 0 01.584-.537 1.413 1.413 0 011.168.421 12.337 12.337 0 013.5 6.122c.713 2.337 1.53 3.925 2.488 6.379"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9232"
            d="M484.838 361.212a18.038 18.038 0 01-11.1-4.942 3.68 3.68 0 01-1.437-2.605 1.168 1.168 0 01.28-.736 1.4 1.4 0 011.25-.164 12.407 12.407 0 015.911 3.879c1.671 1.729 3.143 2.816 5.094 4.568"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9233"
            d="M530.693 368.5c0 1.624-118.8 2.944-265.352 2.944S0 370.124 0 368.5s118.8-2.944 265.34-2.944 265.353 1.297 265.353 2.944z"
            fill="#afe1f2"
          />
          <path
            data-name="Line 226"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M287.83 26.509v25.293"
          />
          <path
            data-name="Line 227"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M235.129 35.797l8.645 23.775"
          />
          <path
            data-name="Line 228"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M188.783 62.55l16.263 19.382"
          />
          <path
            data-name="Line 229"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M154.389 103.545l21.905 12.653"
          />
          <path
            data-name="Line 230"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M136.082 153.828l24.919 4.393"
          />
          <path
            data-name="Line 231"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M136.082 207.336l24.919-4.393"
          />
          <path
            data-name="Line 232"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M154.389 257.619l21.905-12.641"
          />
          <path
            data-name="Line 233"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M188.316 299.898l16.344-19.475"
          />
          <path
            data-name="Line 234"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M234.883 326.769l8.692-23.88"
          />
          <path
            data-name="Line 235"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M287.83 336.116v-25.422"
          />
          <path
            data-name="Line 236"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M340.519 325.368l-8.645-23.775"
          />
          <path
            data-name="Line 237"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M386.866 298.614l-16.263-19.382"
          />
          <path
            data-name="Line 238"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M421.259 257.619l-21.905-12.641"
          />
          <path
            data-name="Line 239"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M439.566 207.336l-24.919-4.393"
          />
          <path
            data-name="Line 240"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M439.566 153.828l-24.919 4.393"
          />
          <path
            data-name="Line 241"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M421.259 103.545l-21.905 12.653"
          />
          <path
            data-name="Line 242"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M386.866 62.55l-16.263 19.382"
          />
          <path
            data-name="Line 243"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M340.519 35.797l-8.645 23.775"
          />
          <path
            data-name="Path 9234"
            d="M308.58 367.822c51.661.7 106.314-1.764 158-1.063 1.741 0 7.384-.467-2.033-6.542-7.979-5.14-33.179-.514-33.179-.514s5.841-2.337 5.841-5.386-2.337-5.713-5.082-7.01a18.88 18.88 0 00-8.947-1.164 56.824 56.824 0 00-18 4.031 5.222 5.222 0 10-6.052-8.482c3.867-5.246 9.849-28.483-8.54-38.729-23.062-12.851-40.574-2.266-44.313 5.456-1.893-7.582-10.6-13.318-16.356-14.744-13.073-3.248-21.59-2.337-33.787 3.411-4.323 2.021-10.106 8.9-12.968 12.711-4.5 5.947-5.2 13.868-5.444 21.333q-.28 8.4-.07 16.788"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9235"
            d="M85.284 367.892c-24.16.327-49.722-.829-73.882-.5-.806 0-3.446-.222.958-3.061 3.727-2.337 15.515-.234 15.515-.234s-2.745-1.1-2.734-2.523a3.855 3.855 0 012.337-3.259 8.867 8.867 0 014.182-.549 26.729 26.729 0 018.412 1.881 2.442 2.442 0 112.839-3.96c-1.811-2.453-4.615-13.318 4-18.108 10.772-6.005 18.961-1.063 20.714 2.547.888-3.5 4.954-6.227 7.629-6.893 6.122-1.519 10.094-1.063 15.807 1.6 2.009.946 4.673 4.159 6.063 5.935 2.091 2.792 2.418 6.5 2.535 9.977q.14 3.925 0 7.863"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9236"
            d="M154.832 132.355l-13.411 139.026a4.323 4.323 0 01-4.673 3.89l-22.431-2.161a4.346 4.346 0 01-3.89-4.673l13.424-139.026a4.311 4.311 0 014.673-3.89l22.419 2.161a4.323 4.323 0 013.89 4.673z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9237"
            d="M151.877 132.028l-2.337 24.627-25.188-2.43 2.337-24.627a1.414 1.414 0 011.53-1.25l22.489 2.208a1.39 1.39 0 011.169 1.472z"
            fill="#f9a66e"
          />
          <path
            data-name="Rectangle 1215"
            fill="#ffb27e"
            d="M121.58 182.953l2.626-27.224 25.188 2.43-2.626 27.224z"
          />
          <path
            data-name="Rectangle 1216"
            fill="#a9d6d3"
            d="M125.419 155.672l.146-1.46 25.305 2.53-.146 1.46z"
          />
          <path
            data-name="Rectangle 1217"
            fill="#fcbf95"
            d="M118.81 211.63l2.626-27.224 25.188 2.43-2.626 27.224z"
          />
          <path
            data-name="Rectangle 1218"
            fill="#a9d6d3"
            d="M121.439 184.438l.14-1.453 25.188 2.434-.14 1.453z"
          />
          <path
            data-name="Rectangle 1219"
            fill="#ffd2b3"
            d="M116.04 240.32l2.626-27.224 25.188 2.43-2.626 27.224z"
          />
          <path
            data-name="Rectangle 1220"
            fill="#a9d6d3"
            d="M118.68 213.133l.14-1.453 25.188 2.434-.14 1.453z"
          />
          <path
            data-name="Path 9238"
            d="M141.094 244.183l-2.594 26.871a1.379 1.379 0 01-1.507 1.25l-22.431-2.161a1.39 1.39 0 01-1.25-1.519l2.594-26.87z"
            fill="#ffe5d4"
          />
          <path
            data-name="Rectangle 1221"
            fill="#a9d6d3"
            d="M117.462 242.12l.146-1.46 25.305 2.53-.146 1.46z"
          />
          <path
            data-name="Rectangle 1222"
            fill="#fdefea"
            d="M122.486 155.379l.146-1.46 31.17 3.116-.146 1.461z"
          />
          <path
            data-name="Rectangle 1223"
            fill="#fdefea"
            d="M119.826 184.194l.146-1.46 31.17 3.116-.146 1.461z"
          />
          <path
            data-name="Rectangle 1224"
            fill="#fdefea"
            d="M115.761 212.851l.14-1.453 31.026 2.998-.14 1.453z"
          />
          <path
            data-name="Rectangle 1225"
            fill="#fdefea"
            d="M113.002 241.534l.14-1.453 31.026 2.998-.14 1.453z"
          />
          <path
            data-name="Path 9239"
            d="M109.246 125.206l32.922 135.708a4.323 4.323 0 01-3.166 5.222l-21.905 5.316a4.334 4.334 0 01-5.222-3.189L78.964 132.554a4.311 4.311 0 013.178-5.2l21.894-5.316a4.323 4.323 0 015.211 3.166z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9240"
            d="M106.395 125.893l5.841 24.043-24.534 5.97-5.841-24.043a1.4 1.4 0 011.028-1.682l21.897-5.314a1.39 1.39 0 011.612 1.028z"
            fill="#5eafbc"
          />
          <path
            data-name="Rectangle 1226"
            fill="#72c5ce"
            d="M87.976 157.348l24.592-5.963 6.445 26.58-24.592 5.963z"
          />
          <path
            data-name="Rectangle 1227"
            fill="#a9d6d3"
            d="M87.657 155.903l24.596-5.972.345 1.42-24.596 5.971z"
          />
          <path
            data-name="Rectangle 1228"
            fill="#93dee2"
            d="M94.785 185.334l24.596-5.972 6.455 26.584-24.596 5.972z"
          />
          <path
            data-name="Rectangle 1229"
            fill="#a9d6d3"
            d="M94.455 183.897l24.596-5.972.345 1.42-24.596 5.971z"
          />
          <path
            data-name="Rectangle 1230"
            fill="#abefef"
            d="M101.563 213.355l24.592-5.963 6.445 26.58-24.592 5.963z"
          />
          <path
            data-name="Rectangle 1231"
            fill="#a9d6d3"
            d="M101.244 211.917l24.596-5.972.345 1.42-24.596 5.971z"
          />
          <path
            data-name="Path 9241"
            d="M132.962 235.398l6.355 26.2a1.379 1.379 0 01-1.016 1.682l-21.891 5.321a1.4 1.4 0 01-1.682-1.051l-6.358-26.217z"
            fill="#cff9f8"
          />
          <path
            data-name="Rectangle 1232"
            fill="#a9d6d3"
            d="M108.041 239.922l24.596-5.972.345 1.42-24.596 5.971z"
          />
          <path
            data-name="Rectangle 1233"
            fill="#fdefea"
            d="M84.807 156.595l30.297-7.356.345 1.419-30.297 7.356z"
          />
          <path
            data-name="Rectangle 1234"
            fill="#fdefea"
            d="M91.605 184.588l30.297-7.356.345 1.419-30.297 7.356z"
          />
          <path
            data-name="Rectangle 1235"
            fill="#fdefea"
            d="M98.394 212.608l30.297-7.356.345 1.419-30.297 7.356z"
          />
          <path
            data-name="Rectangle 1236"
            fill="#fdefea"
            d="M105.192 240.614l30.297-7.356.345 1.419-30.297 7.356z"
          />
          <path
            data-name="Path 9242"
            d="M74.279 140.521l68.345 121.782a4.323 4.323 0 01-1.647 5.841l-19.639 11.087a4.311 4.311 0 01-5.841-1.647L47.093 155.779a4.334 4.334 0 011.659-5.84l19.655-11.03a4.334 4.334 0 015.872 1.612z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9243"
            d="M71.721 141.959l12.115 21.613-22.069 12.379-12.115-21.608a1.4 1.4 0 01.537-1.893l19.651-11.075a1.379 1.379 0 011.881.584z"
            fill="#ffcd69"
          />
          <path
            data-name="Rectangle 1237"
            fill="#ffd385"
            d="M62.478 177.212l22.068-12.384L97.93 188.68l-22.067 12.384z"
          />
          <path
            data-name="Rectangle 1238"
            fill="#a9d6d3"
            d="M61.773 175.909l22.066-12.388.714 1.273-22.065 12.388z"
          />
          <path
            data-name="Rectangle 1239"
            fill="#ffdca4"
            d="M76.582 202.344L98.65 189.96l13.384 23.851-22.067 12.384z"
          />
          <path
            data-name="Rectangle 1240"
            fill="#a9d6d3"
            d="M75.874 201.063l22.068-12.384.714 1.273-22.068 12.384z"
          />
          <path
            data-name="Rectangle 1241"
            fill="#ffe8c7"
            d="M90.68 227.486l22.068-12.384 13.384 23.851-22.067 12.384z"
          />
          <path
            data-name="Rectangle 1242"
            fill="#a9d6d3"
            d="M89.99 226.179l22.066-12.388.714 1.273-22.065 12.388z"
          />
          <path
            data-name="Path 9244"
            d="M126.864 240.223l13.2 23.518a1.39 1.39 0 01-.514 1.893l-19.651 11.029a1.4 1.4 0 01-1.9-.537l-13.204-23.519z"
            fill="#fff3e3"
          />
          <path
            data-name="Rectangle 1243"
            fill="#a9d6d3"
            d="M104.081 251.32l22.068-12.384.714 1.273-22.068 12.384z"
          />
          <path
            data-name="Rectangle 1244"
            fill="#fdefea"
            d="M59.195 177.368l27.182-15.254.715 1.273-27.183 15.254z"
          />
          <path
            data-name="Rectangle 1245"
            fill="#fdefea"
            d="M73.316 202.493l27.18-15.259.714 1.273-27.18 15.26z"
          />
          <path
            data-name="Rectangle 1246"
            fill="#fdefea"
            d="M87.419 227.635l27.182-15.254.715 1.273-27.183 15.254z"
          />
          <path
            data-name="Rectangle 1247"
            fill="#fdefea"
            d="M101.512 252.767l27.182-15.254.715 1.273-27.183 15.254z"
          />
          <path
            data-name="Path 9245"
            d="M118.324 355.17c-40.139-26.379-69.639-67.62-80.939-113.113l1.577-.4c11.192 45.107 40.446 86 80.238 112.155z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9246"
            d="M41.719 254.146a35.831 35.831 0 01-8.645-23.366c0-2.08.315-4.393 1.928-5.713a2.4 2.4 0 011.577-.584 3 3 0 012.091 1.624c2.605 4.124 2.909 9.276 2.675 14.148s.234 8.564.374 13.879"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9247"
            d="M48.075 270.191a35.785 35.785 0 011.317-24.84c.829-1.9 2.044-3.9 4.042-4.463a2.336 2.336 0 011.671.07 3.037 3.037 0 011.287 2.333c.759 4.825-1.016 9.673-3.166 14.019s-3.178 7.944-5.152 12.851"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9248"
            d="M58.005 290.272a35.75 35.75 0 01-1.729-24.849c.584-1.986 1.542-4.124 3.5-4.93a2.337 2.337 0 011.671-.129 3 3 0 011.554 2.161c1.25 4.685.082 9.7-1.472 14.37s-2.173 8.271-3.5 13.424"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9249"
            d="M70.214 308.438a35.714 35.714 0 01-1.729-24.838c.6-2 1.542-4.136 3.5-4.93a2.336 2.336 0 011.671-.129 2.932 2.932 0 011.554 2.15c1.344 4.673.175 9.72-1.414 14.335s-2.185 8.271-3.5 13.412"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9250"
            d="M89.397 330.251a35.785 35.785 0 01-4.3-24.534c.386-2.044 1.168-4.264 2.932-5.269a2.337 2.337 0 011.647-.292 2.991 2.991 0 011.776 1.974c1.823 4.533 1.168 9.65.07 14.4s-1.308 8.458-2.126 13.716"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9251"
            d="M104.854 344.655a38.133 38.133 0 01-5.841-23.576c.152-2.068.6-4.369 2.08-5.619a1.916 1.916 0 011.39-.526c.794.082 1.332.9 1.694 1.694 1.963 4.206 1.846 9.346 1.285 14.195s-.315 8.575-.608 13.832"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9252"
            d="M51.404 277.34a38.694 38.694 0 01-24.534-9c-1.694-1.4-3.388-3.213-3.446-5.351a2.337 2.337 0 01.5-1.624 2.979 2.979 0 012.652-.537c5 .748 9.346 4 13.213 7.465s7.127 5.573 11.566 9.043"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9253"
            d="M59.582 292.643a38.787 38.787 0 01-25.936-2.9c-1.974-.97-4.054-2.337-4.673-4.381a2.337 2.337 0 01.105-1.694 2.991 2.991 0 012.442-1.168c5.035-.467 10.082 1.636 14.615 4.089s8.306 3.739 13.447 6.052"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9254"
            d="M72.516 311.056a38.752 38.752 0 01-25.983 2.337c-2.138-.537-4.475-1.449-5.409-3.353a2.337 2.337 0 01-.234-1.682c.269-.876 1.25-1.332 2.161-1.612 4.837-1.472 10.2-.421 15.188 1.075s8.832 2 14.323 3.236"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9255"
            d="M91.243 332.973a38.729 38.729 0 01-25.819-3.5c-1.951-1-4.007-2.395-4.521-4.475a2.337 2.337 0 01.14-1.694 2.956 2.956 0 012.465-1.1c5.047-.35 10.036 1.858 14.522 4.416s8.178 3.9 13.248 6.32"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9256"
            d="M107.096 346.303a38.81 38.81 0 01-24.651 8.552c-2.2 0-4.673-.351-6.052-1.974a2.255 2.255 0 01-.631-1.565c0-.923.888-1.6 1.706-2.091 4.346-2.594 9.8-2.862 14.954-2.605s9.054-.187 14.674-.315"
            fill="#bae9f4"
          />
          <path
            data-name="Line 244"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M415.641 276.475l-15.083 91.255"
          />
          <path
            data-name="Line 245"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M453.072 276.475l15.083 91.255"
          />
          <path
            data-name="Rectangle 1248"
            fill="#3e89cc"
            d="M362.074 181.295h149.458v108.931H362.074z"
          />
          <path
            data-name="Rectangle 1249"
            fill="#eefbff"
            d="M367.916 185.559h137.776v100.426H367.916z"
          />
          <path
            data-name="Line 246"
            fill="none"
            stroke="#3e89cc"
            strokeMiterlimit={10}
            strokeWidth={3}
            d="M407.17 327.704h54.372"
          />
          <text
            transform="rotate(.573 -24188.03 41912.468)"
            fill="#3e89cc"
            fontSize={24}
            fontFamily="SegoeUI, Segoe UI"
          >
            <tspan x={0} y={0}>
              {"idea"}
            </tspan>
          </text>
          <path
            data-name="Path 9257"
            d="M165.674 367.822H79.899l-14.4-155.113a3.166 3.166 0 012.769-3.7H177.31a3.166 3.166 0 012.769 3.7z"
            fill="#81d9fc"
          />
          <path
            data-name="Path 9258"
            d="M250.468 336.828v31.193H94.187a6.566 6.566 0 01-6.566-6.519v-22.548a6.391 6.391 0 01.35-2.126z"
            fill="#2775af"
          />
          <path
            data-name="Path 9259"
            d="M250.468 336.828v27.069H88.077a6.519 6.519 0 01-.456-2.395v-22.548a6.391 6.391 0 01.35-2.126z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1250"
            fill="#c3ecfe"
            d="M87.621 339.959h179.086v1.717H87.621z"
          />
          <path
            data-name="Rectangle 1251"
            fill="#c3ecfe"
            d="M87.621 343.826h179.086v1.717H87.621z"
          />
          <path
            data-name="Rectangle 1252"
            fill="#c3ecfe"
            d="M87.621 347.693h179.086v1.717H87.621z"
          />
          <path
            data-name="Rectangle 1253"
            fill="#c3ecfe"
            d="M87.621 351.56h179.086v1.717H87.621z"
          />
          <path
            data-name="Rectangle 1254"
            fill="#c3ecfe"
            d="M87.621 355.427h179.086v1.729H87.621z"
          />
          <path
            data-name="Rectangle 1255"
            fill="#c3ecfe"
            d="M87.621 359.294h179.086v1.729H87.621z"
          />
          <path
            data-name="Path 9260"
            d="M208.889 335.59h-6.788v19.242l6.788-5.584 6.788 5.584v-16.438z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9261"
            d="M209.87 334.024l-6.8 2.8v16.449l6.8-5.584 6.788 5.584v-16.449z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9262"
            d="M250.472 332.377v4.451h-162.5a6.542 6.542 0 016.215-4.451z"
            fill="#2775af"
          />
          <path
            data-name="Path 9263"
            d="M261.766 301.429v31.193H105.485a6.519 6.519 0 01-6.1-4.159 6.356 6.356 0 01-.467-2.407v-22.547a6.379 6.379 0 01.386-2.08z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9264"
            d="M261.766 301.429v27.069H99.374a6.355 6.355 0 01-.467-2.407v-22.547a6.379 6.379 0 01.4-2.115z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1256"
            fill="#c3ecfe"
            d="M98.919 304.525h179.086v1.717H98.919z"
          />
          <path
            data-name="Rectangle 1257"
            fill="#c3ecfe"
            d="M98.919 308.392h179.086v1.717H98.919z"
          />
          <path
            data-name="Rectangle 1258"
            fill="#c3ecfe"
            d="M98.919 312.259h179.086v1.717H98.919z"
          />
          <path
            data-name="Rectangle 1259"
            fill="#c3ecfe"
            d="M98.919 316.114h179.086v1.729H98.919z"
          />
          <path
            data-name="Rectangle 1260"
            fill="#c3ecfe"
            d="M98.919 319.981h179.086v1.741H98.919z"
          />
          <path
            data-name="Rectangle 1261"
            fill="#c3ecfe"
            d="M98.919 323.848h179.086v1.741H98.919z"
          />
          <path
            data-name="Path 9265"
            d="M123.184 300.483l-6.788-.865v20.118l6.788-5.584 6.788 5.584v-16.45z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9266"
            d="M124.691 298.59l-6.788 2.8v16.449l6.788-5.584 6.788 5.584v-16.445z"
            fill="#ffc840"
          />
          <path
            data-name="Path 9267"
            d="M261.765 296.931v4.5H99.304a6.554 6.554 0 016.2-4.463z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9268"
            d="M492.49 236.753a.841.841 0 00.759-.829.865.865 0 00-1.717 0 .841.841 0 00.631.806c-.584 4.381-5.841 7.816-12.36 7.921h-.6c-6.472-.105-11.776-3.5-12.36-7.921a.829.829 0 00.631-.806.853.853 0 10-1.706 0 .841.841 0 00.748.829c.5 3.8 4.381 6.9 9.51 7.9h-9.019a.841.841 0 00-.818-.678.853.853 0 100 1.706.841.841 0 00.818-.678h23.8a.841.841 0 00.818.678.853.853 0 100-1.706.841.841 0 00-.818.678h-7.827c5.14-.995 9.007-4.103 9.51-7.9z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9269"
            d="M486.322 235.573l-6.764 9.253-.491-12.851a2.57 2.57 0 10-1.828-.74 2.559 2.559 0 001.828.74l-.117 12.851s-4.591-6.484-7.01-9.545c1.075-2.944 2.337-11.11 2.7-13.821.093-.549.14-.876.14-.876h8.891a2.914 2.914 0 00.093.876c.583 4.767 2.558 14.113 2.558 14.113z"
            fill="#71606e"
          />
          <path
            data-name="Path 9270"
            d="M483.798 221.46h-9.183c.093-.549.14-.876.14-.876h8.91c.063.234.086.572.133.876z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9271"
            d="M485.433 217.312v2.687a.911.911 0 01-.911.923h-10.807a.923.923 0 01-.911-.853v-2.757a.911.911 0 01.911-.911h10.807a.911.911 0 01.911.911z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9272"
            d="M485.433 217.312v2.687a.911.911 0 01-.911.923h-10.807a.923.923 0 01-.911-.853c8.914.526 8.692-2.582 8.353-3.668h3.365a.911.911 0 01.911.911z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9273"
            d="M330.427 324.339v7.465a8.377 8.377 0 01-8.365 8.365h-74a8.377 8.377 0 01-8.365-8.33v-7.442a8.365 8.365 0 018.365-8.365h74a8.365 8.365 0 018.365 8.307z"
            fill="#71606e"
          />
          <path
            data-name="Path 9274"
            d="M330.427 352.577v7.4a8.377 8.377 0 01-8.365 8.377h-74a8.388 8.388 0 01-8.365-8.377v-7.4a8.377 8.377 0 018.365-8.377h74a8.377 8.377 0 018.365 8.377z"
            fill="#71606e"
          />
          <path
            data-name="Path 9275"
            d="M395.85 181.426a107.936 107.936 0 01-23.845 67.831 105.271 105.271 0 01-11.531 12.29 107.622 107.622 0 01-17.641 13.108 50.517 50.517 0 00-24.768 39.5c0 .6-.07 1.168-.093 1.823h-65.821a54.536 54.536 0 00-8.657-27.4 58.673 58.673 0 00-3.949-5.479 55.015 55.015 0 00-11.683-11.005 108.335 108.335 0 01-48.881-89.877c-.409-59.3 47.608-108.382 106.91-109.2a109.913 109.913 0 0112.3.514 108.452 108.452 0 0197.659 107.895z"
            fill="#ffc840"
          />
          <path
            data-name="Rectangle 1262"
            fill="#443a43"
            d="M246.987 339.936h76.137v4.276h-76.137z"
          />
          <path
            data-name="Path 9276"
            d="M395.85 181.423a108.381 108.381 0 01-53.017 93.229 52.292 52.292 0 00-25.13 41.124q-32.642.514-65.307 0a56.194 56.194 0 00-8.68-26.532c29.6-3.774 59.372-12.255 83.182-30.235 46.381-35.048 49.617-97.1 19.242-144.1a114.082 114.082 0 00-47.982-41.412 108.452 108.452 0 0197.692 107.926z"
            fill="#ffb839"
            opacity={0.2}
          />
          <path
            data-name="Path 9277"
            d="M330.427 324.339v7.465a8.377 8.377 0 01-8.365 8.365h-74a8.377 8.377 0 01-8.365-8.33c56.241 5.679 61.83-11.016 62.293-15.806h20.071a8.365 8.365 0 018.365 8.307z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9278"
            d="M330.426 352.577v7.4a8.377 8.377 0 01-8.365 8.377h-74a8.377 8.377 0 01-8.178-6.741c68.309 5.841 56.3-17.407 56.3-17.407h25.9a8.377 8.377 0 018.343 8.371z"
            fill="#71606e"
            opacity={0.2}
          />
          <g
            data-name="Group 467"
            opacity={0.5}
            fill="none"
            stroke="#ffe1b0"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
          >
            <path
              data-name="Path 9279"
              d="M214.602 131.245c-9.346 14.592-16.356 36.217-13.926 67.959"
            />
            <path
              data-name="Path 9280"
              d="M248.54 103.195a58.063 58.063 0 00-16.788 9.346"
            />
          </g>
          <path
            data-name="Path 9281"
            d="M156.398 216.366a2.78 2.78 0 011.647 2.044 2.722 2.722 0 01-.876 2.465 1.5 1.5 0 011.168 1.706 3.75 3.75 0 01-1.168 2.009 3.411 3.411 0 01-2.337 1.332 2.605 2.605 0 01-1.752-.759 3.248 3.248 0 01-.806-1.168 5.374 5.374 0 01-.292-1.554c-.164-1.858-.315-3.715-.479-5.573a1.367 1.367 0 01.222-1.075"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9282"
            d="M140.381 228.633c-.117 2.418 0 6.624-.643 7.243s-5.549.6-5.549.6 10.608 10.012 11.321 9.463 10.152-8.248 8.026-8.645-4.194-.3-4.136-1.4.129-2.2.187-3.295"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9283"
            d="M131.291 282.503s15.562 1.764 19.148 1.834 3.4-1.787 3.4-1.787c.187-3.949.853-13.248 1.589-16.356.7-2.944 1-4.031 1.6-6.823 1.344-6.215 1.285-7.4 2.7-15.059l-9.288-7.477a4.907 4.907 0 01-4.86 2.909c-5.211.07-6.834-3.587-6.834-3.587l-12.676 8.423-1.168 20.48 4.778 15.643"
            fill="#0094bc"
          />
          <path
            data-name="Path 9284"
            d="M140.194 226.449a27.444 27.444 0 001.1 3.575 4.054 4.054 0 004.3 2.956l4.767.117a5.479 5.479 0 003.715-.783c.981-.853 1-2.337 1.168-3.5.28-1.5.5-3.014.678-4.533a67.589 67.589 0 00.421-8.961 7.008 7.008 0 00-.105-1.227.818.818 0 00-.21-.456.958.958 0 00-.572-.222 48.368 48.368 0 00-9.007-.572 10.176 10.176 0 00-6.063 1.612c-1.694 1.308-2.5 3.435-3.224 5.456-.117.315-.2.748.082.946"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9285"
            d="M174.261 334.935a33.339 33.339 0 01-.9 4.019c-.4 1.028-3.75.082-3.972-.584s1.051-5.526 1.051-5.526"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9286"
            d="M168.233 339.223c-.292 1.1-.654 3.213-.654 3.213l3.353 1.46.549-.514a6.262 6.262 0 001.858 1.484 14.263 14.263 0 003.248.9c2.932.315 5.082-.234 5.257-.643.724-1.694-3.154-2.15-3.925-2.337a5.14 5.14 0 01-3.68-3.692c-.175-.888 0-1.04-.456-1.016a1.168 1.168 0 00-.829.4 2.138 2.138 0 01-2.337.549 2.43 2.43 0 01-1.168-.993 1.472 1.472 0 00-1.216 1.189z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9287"
            d="M159.435 295.845c5.246 1.028 11.589 1.8 16.893 1.1-.748 2.115-2.337 4.147-3.014 7.138-2.337 9.884-3.084 23.144-3.657 31.357 0 0 1.1 2.1 4.6.5 5.257-12.98 14.428-39.254 14.335-44.967-.105-7.255-18.225-9.007-31.544-10.795"
            fill="#243a6c"
          />
          <g data-name="Group 468">
            <path
              data-name="Path 9288"
              d="M136.292 281.311c-4.171 3.049 23.144 14.533 23.144 14.533a45.178 45.178 0 008.961.853 6.823 6.823 0 00.666-1.694c.152-.794.07-1.612.21-2.418a5.619 5.619 0 012.734-3.68 12.36 12.36 0 014.463-1.437 60.228 60.228 0 0110.141-.187c-8.178-6.052-24.183-4.673-32.011-5.175-1.496 2.465-17.712-1.239-18.308-.795z"
              fill="#40536d"
              opacity={0.5}
            />
          </g>
          <g data-name="Group 469">
            <path
              data-name="Path 9289"
              d="M171.936 337.705a34.34 34.34 0 01-.444 2.068h.152c.5 0 .28.128.444 1.016a5.187 5.187 0 003.68 3.692c.771.2 4.673.654 3.937 2.336-.175.409-2.337.958-5.257.643a14.1 14.1 0 01-3.248-.9 6.262 6.262 0 01-1.858-1.484l-.561.514-3.353-1.46s.374-2.115.666-3.213a1.46 1.46 0 011.168-1.168 16.867 16.867 0 01.409-2.407 1.777 1.777 0 01-.129-.187c.584-8.178 1.379-21.461 3.657-31.345a18.622 18.622 0 011.706-4.381 22.045 22.045 0 001.273-2.757 41.1 41.1 0 01-7.8.14 25.251 25.251 0 01-.093 2.617c-.526 11.683-2.465 29.114-2.185 42.946a2.92 2.92 0 01-.643.374 17 17 0 01-.082 2.033h.152c.479-.117.292.082.619.923a5.129 5.129 0 004.264 2.991c.794.07 4.673-.152 4.276 1.636-.105.432-2.126 1.344-5.07 1.542a14.019 14.019 0 01-3.353-.315 6.2 6.2 0 01-2.091-1.168l-.456.607-3.5-.865s0-2.138.093-3.283a1.449 1.449 0 01.911-1.367 18.688 18.688 0 010-2.605 10.17 10.17 0 01-1-.374c-.876-9.51-6.145-30.983-3.5-43.051a18.45 18.45 0 01.748-2.64c-9.86 1.308-18.354 2.535-27.314-.432a4.521 4.521 0 01-2.126-1.39h59.91a54.83 54.83 0 01-1.168 4.463c-2.909 10.515-8.75 26.87-12.559 36.217z"
              fill="#595959"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9290"
            d="M165.604 341.84a33.692 33.692 0 01-.187 4.112c-.222 1.075-3.692.724-4.019.117s.082-5.619.082-5.619"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9291"
            d="M160.39 347.105c-.093 1.168-.093 3.283-.093 3.283l3.5.853.456-.607a6.238 6.238 0 002.08 1.168 14.122 14.122 0 003.353.315c2.944-.187 4.965-1.11 5.07-1.542.421-1.787-3.5-1.565-4.276-1.636a5.141 5.141 0 01-4.264-2.991c-.327-.841-.128-1.04-.619-.923a1.168 1.168 0 00-.759.537 2.126 2.126 0 01-2.243.958 2.558 2.558 0 01-1.344-.771 1.46 1.46 0 00-.861 1.356z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9292"
            d="M127.18 280.704c-1.4 3.26-2.337 9.136-.911 11.683 1.168 2.208 1.811 3.575 3.914 4.276 8.949 2.967 17.442 1.741 27.3.432-4.171 11.286 1.881 35.446 2.816 45.692 3.8 1.682 5.935-.105 5.935-.105-.421-20.854 4.217-49.979 1.414-54.909-1.717-3.026-22.127-7.01-22.536-7.01"
            fill="#243a6c"
          />
          <path
            data-name="Path 9293"
            d="M142.822 222.791c-.175-.724-1.285-.771-1.787-.234a3.119 3.119 0 00-.6 2.08 4.93 4.93 0 00.9 2.617c.479.771 1.168 1.227 1.858.584a2.337 2.337 0 01-1.951 2.477 2.161 2.161 0 01-2.138-1.472c-4.042 1.484-5.316-4.369-5.561-7.29a12.045 12.045 0 011.823-7.01 4.965 4.965 0 012.921-2.2 4.673 4.673 0 012.5-3.5 12.2 12.2 0 013.914-1.367c.9-.187 3.353.479 3.809 1.39 1.717-.981 3.248 0 4.6.129s2.886 1.425 2.337 2.664a3.271 3.271 0 013.809 3.925 3.5 3.5 0 01-5.444 1.53 4.1 4.1 0 01-3.75 2.2 7.968 7.968 0 01-4.276-1.484 3.236 3.236 0 01.152 2.792c-.421.923-.759 1.612-2.126 1.332 0 0 .117 2.115-.362 1.916s-.628-1.079-.628-1.079z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9294"
            d="M170.102 275.423c-5.432-7.839-8.342-14.019-13.073-22.291l-6.589-16.356 2.652.164a19.942 19.942 0 015.491 1.04 11.426 11.426 0 016.355 5.105c1.1 2.2 1.764 4.591 2.687 6.858 1.04 2.535 2.138 5.035 3.248 7.547 2.2 4.965 4.439 9.93 6.3 15.036"
            fill="#0094bc"
          />
          <path
            data-name="Path 9295"
            d="M157.94 254.741l.888-5.3 6.507 14.265-2.15.526z"
            fill="#070707"
            opacity={0.2}
          />
          <path
            data-name="Path 9296"
            d="M126.011 244.277a161.819 161.819 0 00.7 30.551 67.393 67.393 0 001.332 8.388c.082.35.678.292.643-.082-.222-2.5-.666-4.977-.97-7.465s-.572-5.094-.771-7.641q-.6-7.535-.526-15.083c0-2.886.105-5.783.257-8.669a.333.333 0 00-.666 0z"
          />
          <path
            data-name="Rectangle 1263"
            fill="#aabde2"
            d="M134.843 282.152h50.283v1.811h-50.283z"
          />
          <path
            data-name="Path 9297"
            d="M194.087 283.903H153.84l7.22-23.518a3.084 3.084 0 012.956-2.182h35.244a2.009 2.009 0 011.916 2.594z"
            fill="#aabde2"
          />
          <path
            data-name="Path 9298"
            d="M194.589 283.903h-39.64l7.22-23.518a3.084 3.084 0 012.956-2.182h35.247a2 2 0 011.916 2.594l-6.916 22.536a.818.818 0 01-.783.57z"
            fill="#e1e8f9"
          />
          <g data-name="Group 470">
            <path
              data-name="Path 9299"
              d="M131.9 248.53c2.08 9.346 2.944 20.188 3.5 26.871 7.769.572 9.954 3.5 17.069 6.729 0 0 5.631-.935 6.215 1.168.35 1.227-6.577 2.2-6.577 2.2-6.6 0-22.595-3.061-23.775-3.376s-6.017-24.183-6.157-36.217a7.442 7.442 0 011.173-4.891 6.332 6.332 0 012.15-1.589 29.932 29.932 0 0113.283-3.365"
              fill="#070707"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9300"
            d="M151.515 283.601a4.171 4.171 0 013.5-1.1 24.55 24.55 0 012.7.234c.421 0 .911.152.946.607s-2.033 0-3.131.315a54.044 54.044 0 006.449.175 1.964 1.964 0 01.736.082.619.619 0 01.421.561.771.771 0 01-.292.491 4.44 4.44 0 01-2.22.9 17.15 17.15 0 01-9.79-.865"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9301"
            d="M132.109 248.541c.175 10.012 1.612 19.113 1.414 29.137 7.769.572 11.683 2.08 18.844 5.246a3.785 3.785 0 01-.234 2.605c-.549.2-23.261-.759-25.13-2.477-1.671-1.542-4.673-25.083-4.8-37.093a7.442 7.442 0 011.168-4.883 6.332 6.332 0 012.15-1.589 29.932 29.932 0 0113.283-3.365"
            fill="#0094bc"
          />
          <path
            data-name="Path 9302"
            d="M155.008 222.313s2.337 4.206 2.021 4.743-3.178 0-3.178 0"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9303"
            d="M176.329 270.493a4.194 4.194 0 101.224-2.973 4.194 4.194 0 00-1.224 2.973z"
            fill="#fff"
          />
          <path
            data-name="Path 9304"
            d="M384.424 229.918a109.326 109.326 0 006.11-14.837 4.533 4.533 0 01-1.5-.362c-6.355-3.68-5.771 2.862-4.872 5.327.3.841.993 1.9 1.168 2.337a22.026 22.026 0 01-.152 2.816 1.507 1.507 0 00.678 1.168 14.767 14.767 0 01-1.063 2.71 1.87 1.87 0 00-.374.841zm2.126-6.017a.732.732 0 000-.117v.175a.491.491 0 010-.058zm-16.134 25.7c-2.5.619-3.353 0-3.353 0a51.169 51.169 0 00-4.907-1.869c-1.309-.456-2.991-1.168-4.767-1.881l-25.775-26.015-2.161-2.08a10.825 10.825 0 000-1.893c-.164-2.337-1.11-6.239-5.292-7.524s-7.313.339-10.3-.794l-3.984-3.5-.152-.234v.117c1.449 6.706 1.168 20.959 13.575 20.235l1.974 2 12.851 12.933c1.355 2.547 5.035 5.175 5.339 5.386l16.963 17.127a105.277 105.277 0 0011.531-12.29l-1.449.374z"
            opacity={0.2}
          />
          <path
            data-name="Path 9305"
            d="M364.306 398.183c0 1.472 16.508 2.664 36.871 2.664s36.859-1.164 36.859-2.664-16.508-2.664-36.859-2.664-36.871 1.196-36.871 2.664z"
            fill="#afe1f2"
          />
          <path
            data-name="Path 9306"
            d="M394.876 245.807a3.329 3.329 0 01-1.075 1.858 3.867 3.867 0 01-2.2 1c-2.173.222-5.526.689-9.078 1.168-5.69.759-11.893 1.542-14.51 1.4a13.7 13.7 0 01-4.615-.643h-.14c-.386-.339-.4-1.262-.28-2.173s.362-2 .386-2.266a4.474 4.474 0 013.6-3.879 4.053 4.053 0 01.6-.117l.4-.129c5.339-1.694 11.379-2.115 15.269-2.769a12.852 12.852 0 015.631.292 11.484 11.484 0 013.5 1.624c1.639 1.082 2.959 2.659 2.512 4.634z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9307"
            d="M368.747 248.354a3.985 3.985 0 01-.537 1.016 4.787 4.787 0 01-.327.35 4.953 4.953 0 01-3.949 1.028l-.491-.164-.164-.07c-3.411-1.449-10.655-6.753-15.6-10.515-2.956-2.278-5.094-3.984-5.094-3.984l.444-.678 1.752-2.57s10.994 5.2 16.192 7.01a33.88 33.88 0 016.052 2.465 6.689 6.689 0 01.561.374 6.25 6.25 0 011.161 5.738z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9308"
            d="M382.555 249.826c-5.69.759-11.893 1.542-14.51 1.4a13.7 13.7 0 01-4.615-.643h-.14c-3.411-1.449-10.655-6.753-15.6-10.515.713.432 10.082 5.841 15.316 8.365a17.366 17.366 0 002.956 1.168 10.691 10.691 0 001.939.175h.292a14.019 14.019 0 0011.765-6.764 25.594 25.594 0 012.337-3.166s.154 5.833.26 9.98z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9309"
            d="M365.825 241.59s.853.619 3.353 0-.128 2.442-.128 2.442l-3.937-.245-.327-1.016z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9310"
            d="M405.652 270.271a14.8 14.8 0 00-.666 8.6c1.262 5.7-.175 6.075-.175 6.075s-7.734 4.907-14.16 6.916c-4.6 1.425-8.528 1.168-8.412-3.9v-.958c.21-11.426-2.161-12.01-2.757-24.8-.607-13.132-.467-20.9 3.727-23.015 4.58-2.337 10.888-3.89 19.861-1.776 6.706 1.577 8.926 3.353 8.867 8.33a40.349 40.349 0 01-.724 6.11 110.611 110.611 0 01-5.561 18.424z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9311"
            d="M405.652 270.271a14.8 14.8 0 00-.666 8.6c1.262 5.7-.175 6.075-.175 6.075s-7.734 4.907-14.16 6.916l-5.993-.572-2.407-1.893v-2.395a44.7 44.7 0 009.066-.234 38 38 0 008.891-2.231 3.5 3.5 0 002.185-3.844 49.712 49.712 0 01-.83-7.979 41.746 41.746 0 012.138-9.825 19.93 19.93 0 00.794-7.278 65.516 65.516 0 010-8.283l4.755-2.582 2.652.993a40.357 40.357 0 01-.724 6.11 110.613 110.613 0 01-5.526 18.422z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9312"
            d="M384.155 223.505c.876.35.514 3.33.678 4.288s.853 4.673 2.816 5.257 3.178.724 3.178 1.051a11.863 11.863 0 01-.093 1.507 3.539 3.539 0 01-.058.806c-.058.234 0 .14 0 .187a.373.373 0 000 .152 3.855 3.855 0 00.175 1.39l1.285.853a1.016 1.016 0 00.666.35l1.355.105a.806.806 0 00.292 0l.759-.222c.105-.456.175-.806.187-.818s2.407-1.589 3.785-2.5a31.817 31.817 0 01.3-3.5c.082-.351 1.1-2.337 2.15-4.673l.257-.6c.234-.526.456-1.063.678-1.6a.677.677 0 00.093-.21 16.543 16.543 0 001.355-5.035c0-3.435-.117-7.01-2.243-8.8s-15.433-8.073-15.877 2.278a1.051 1.051 0 010 .187 47.905 47.905 0 01-2.337 7.01 1.647 1.647 0 00.6 2.535z"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9313"
            d="M390.814 238.143l.128.643a.958.958 0 00.958.771l2.278-.093a.6.6 0 00.234 0l.759-.222c.105-.456.175-.806.187-.818s2.407-1.589 3.785-2.5a31.8 31.8 0 01.3-3.5c.082-.35 1.1-2.337 2.15-4.673l.257-.6c.234-.526.456-1.063.678-1.6a.957.957 0 00.07-.444l-.093-1.028a.923.923 0 00-.829-.853c-1.168-.129-3.143-.35-3.248-.339a14.849 14.849 0 00-1.379 2.512c0 .105.572 1.834.724 2.337a1.659 1.659 0 010 .234c0 .526.093 2.675 0 4.673a3.949 3.949 0 01-2.033 3.353l-.175.093a33.778 33.778 0 01-4.755 2.056z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9314"
            d="M383.583 224.451c-2.851 2.594.245 8.178 1.168 9.019s7.477 2.792 11.239-.829a7.008 7.008 0 001.612-2.337 13 13 0 00.888-5.152l1.075.269a29.693 29.693 0 01-.187 5.409.935.935 0 001.577.678c1.706-1.671 4.288-5.327 5.164-12.676 1.344-11.286-9.965-12.057-12.512-11.8-1.823.2-4.965.093-5.841-.4-6.367-3.668-5.771 2.874-4.872 5.339a21.691 21.691 0 001.168 2.278 22.366 22.366 0 01-.164 2.827 1.542 1.542 0 00.689 1.168s.643-2.115.724-2.418.327-1.168.444-1.589a.444.444 0 01.257-.28 4.919 4.919 0 01.794-.222 27.454 27.454 0 013.341-.28 1.53 1.53 0 011.612 1.46c.152 3.5 1.963 4.171 2.792 4.276a.491.491 0 01.444.444c.549 4.3-1.1 6.706-1.811 6.823s-2.979-1.787-2.979-1.787-3.772-2.826-6.622-.22z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9315"
            d="M398.139 222.287s.175-1.928 1.659-1.659c1.752.315 2.629 4.416-.082 5.409a.923.923 0 01-1.227-.865 13.28 13.28 0 00-.35-2.886z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9316"
            d="M389.436 242.15s-7.01 22.828-5.573 33.763l2.57 4.673 2.8-5.094s-2.278-21.859 2.091-32.957z"
            fill="#16405a"
          />
          <path
            data-name="Path 9317"
            d="M388.957 240.211v.3a6.064 6.064 0 00.444 1.636l1.893.386 1.636-1.168-1.881-2.2-.292.082a4.042 4.042 0 00-1.811.981z"
            fill="#103649"
          />
          <path
            data-name="Path 9318"
            d="M399.191 234.977a22.205 22.205 0 011.379 1.916 15.618 15.618 0 00-2.395 1.168c-.981.6-5.7 3.937-5.7 3.937l-1.39-2.862s5.442-3.411 8.106-4.159z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9319"
            d="M391.083 239.125a3.972 3.972 0 00-2.161 1.8s-.806-2.442-.129-3.785a3.692 3.692 0 011.963-1.881z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9320"
            d="M383.722 390.534a8.271 8.271 0 00-.573 2.781c.082 1.168 3.6 1.168 4.007.619s.619-5.643.619-5.643"
            fill="#feaf84"
          />
          <path
            data-name="Path 9321"
            d="M388.092 394.892a22.866 22.866 0 01-.327 3.026h-4.054l-.2-.678a6.321 6.321 0 01-2.337.678h-3.423c-2.5 0-3.925-.315-3.984-.759-.269-1.846 2.722-1.752 3.5-1.752 2.243 0 4.673-1.051 5.187-2.185.385-.829.21-1.028.678-.876a1.168 1.168 0 01.7.6 2.044 2.044 0 002.1 1.168 2.512 2.512 0 001.379-.666 1.484 1.484 0 01.781 1.444z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9322"
            d="M423.14 386.713a33.663 33.663 0 001.227 3.961c.491.993 3.785-.222 3.949-.911s-1.519-5.468-1.519-5.468"
            fill="#feaf84"
          />
          <path
            data-name="Path 9323"
            d="M429.542 390.324c.432 1.075 1.063 3.143 1.063 3.143l-3.014 1.834-.607-.456a5.959 5.959 0 01-1.612 1.682 13.246 13.246 0 01-3.038 1.262c-2.8.643-4.977.327-5.2-.058-.923-1.612 2.792-2.5 3.5-2.781a5 5 0 003.1-4.089c0-.911-.187-1.04.3-1.075a1.168 1.168 0 01.865.3 2.056 2.056 0 002.337.292 2.453 2.453 0 001.028-1.168 1.472 1.472 0 011.273 1.11z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9324"
            d="M408.899 307.703s5.514-13.178-4.089-22.758c0 0-8.178 3.668-14.755 4.112a32.349 32.349 0 01-7.792-.187 120.151 120.151 0 00-1.4 25.41z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9325"
            d="M388.256 391.807h-.491a28.249 28.249 0 01-5.362-.362v-.993c.187-15.083-1.636-39.722-1.986-47.549a8.668 8.668 0 010-1.484c.584-5.713 6.484-4.965 8.961.28a20.185 20.185 0 011.4 4.031 35.919 35.919 0 01.911 5.7c1.203 13.086-2.429 30.61-3.433 40.377z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9326"
            d="M398.479 313.778a2.423 2.423 0 01-.093.491c-1.308 6.87-5.538 25.434-7.559 31.462a3.645 3.645 0 01-2.594 1.9c-2.967.806-7.4-.3-7.769-6.215a14.673 14.673 0 010-2.138c.245-3.084.467-16.263.409-25.025a35.259 35.259 0 011.25-8.891c.2-2.57.666-6.309 2.009-6.776 6.776-2.325 16.111 5.588 14.347 15.192z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9327"
            d="M391.737 351.443c1.168 13.026-2.477 30.644-3.5 40.364h-.491s.841-15.41 2.22-26.088a42.4 42.4 0 00-1.752-18.085c-.28-.829-.467-1.285-.467-1.285l1.659-4.673c1.858-6.052 1.9-20.165 1.9-20.165-4.51-9.942-5.14-22.466-5.14-22.466l3.855.537 6.9 8.283 1.46 6.414c-1.308 6.87-5.538 25.434-7.559 31.462a35.9 35.9 0 01.911 5.7z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9328"
            d="M392.181 341.151a33.3 33.3 0 00-.444 10.328c.724 5.094-2.442-4.5-2.442-4.5l1.682-3.5z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9329"
            d="M411.925 341.326c-4.568-4.3-10.923-2.266-7.956 4.4 3.178 7.1 12.991 26.964 18.319 41.053l.362.923a29.138 29.138 0 005.573-1.811c-2.535-9.159-4.369-24.955-9.638-35.96a29.908 29.908 0 00-6.659-8.61z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9330"
            d="M386.188 299.092c-.888-10.62 12.337-3.563 18.693-.07 2.675 1.484 3.645 4.428 4.007 7.208s3.785 31.38 4.475 36.6c1.554 11.753-8.727 5.327-9.7 2.068-2.451-8.234-16.961-39.964-17.475-45.806z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9331"
            d="M412.404 335.531s.421 5.631 5.152 12.571c0 0-7.746-3.563-8.12-4.089a29.055 29.055 0 01-1.577-6.566c.19-.572 4.545-1.916 4.545-1.916z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9332"
            d="M399.553 289.139l.6.526s4.673-4.066 8.33-7.5c3.376-3.2 6.811-6.776 8.949-11.052a5.845 5.845 0 00.292-.608 1.422 1.422 0 00.093-.374 1.169 1.169 0 000-.21 1.26 1.26 0 000-.222v-.63a2.839 2.839 0 000-.315 20.717 20.717 0 00-.257-3.073c-.385-4.217-4.556-17.431-5.982-22.945a3.726 3.726 0 00-1.3-2.033 3.33 3.33 0 00-1.974-.783h-.339c.876 1.414 2.126 4.276 3.5 10 1.858 7.641 3.166 12.267 3.692 15.188a10.164 10.164 0 01.234 3.189 9.638 9.638 0 01-1.332 2.781c-3.006 5.326-11.165 15.771-14.506 18.061z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9333"
            d="M322.154 216.039c4.825-3.33 6.11-6.344 6.11-6.344a10.826 10.826 0 000-1.893c-.175-2.337-1.11-6.25-5.292-7.535-6.18-1.881-9.86 2.442-14.44-4.58v.117c1.484 6.707 1.227 20.971 13.622 20.235z"
            fill="#fff"
          />
          <path
            data-name="Path 9334"
            d="M322.154 216.04c4.825-3.33 6.11-6.344 6.11-6.344a10.823 10.823 0 000-1.893c-13.225 13.926-19.277-10.176-19.709-12 1.46 6.712 1.203 20.973 13.599 20.237z"
            fill="#ffe7c5"
          />
          <g data-name="Group 471">
            <path
              data-name="Path 9335"
              d="M308.567 195.805a13 13 0 004.229 5.024 9.755 9.755 0 002.909 1.472 14.719 14.719 0 003.248.479 13.7 13.7 0 013.376.526 6.671 6.671 0 012.886 1.928 6.437 6.437 0 011.437 3.119 7.127 7.127 0 01-.339 3.365 6.741 6.741 0 00-1.531-6.087 6.308 6.308 0 00-2.664-1.694 19.1 19.1 0 00-3.236-.479 15.374 15.374 0 01-3.365-.572 10.187 10.187 0 01-2.991-1.682 11.986 11.986 0 01-3.961-5.4z"
              fill="#ffe7c5"
            />
          </g>
          <g data-name="Group 472">
            <path
              data-name="Path 9336"
              d="M308.567 195.805a21.028 21.028 0 002.769 5.561 14.569 14.569 0 004.463 4.159 23.114 23.114 0 002.839 1.238 14.509 14.509 0 012.816 1.507 7.537 7.537 0 012.2 2.337 6.332 6.332 0 01.771 3.061 6.729 6.729 0 00-3.295-4.93 14.276 14.276 0 00-2.734-1.379 15.6 15.6 0 01-2.921-1.273 13.576 13.576 0 01-4.533-4.463 17.011 17.011 0 01-2.375-5.818z"
              fill="#ffe7c5"
            />
          </g>
          <path
            data-name="Path 9337"
            d="M418.012 310.998a2.993 2.993 0 01-.958-.152c-3.668-1.168-5.059-9.241-5.211-10.164l-.164-1.04 1.016.269c.9.234 8.844 2.407 9.79 6.04a3.5 3.5 0 01-1.262 3.423 4.755 4.755 0 01-3.213 1.624zm-4.6-9.451c.561 2.687 1.963 7.3 4.077 7.991.806.257 1.741-.129 2.769-1.168a2.173 2.173 0 00.9-2.1c-.576-2.072-5.097-3.898-7.749-4.724z"
            fill="#0b0b3a"
          />
          <path
            data-name="Rectangle 1264"
            fill="#ffc25b"
            d="M324.125 218.057l6.254-6.202 85.686 86.416-6.255 6.202z"
          />
          <path
            data-name="Rectangle 1265"
            fill="#ffa92c"
            d="M321.954 215.88l6.254-6.202 2.164 2.182-6.255 6.202z"
          />
          <path
            data-name="Rectangle 1266"
            fill="#ff8736"
            d="M324.125 218.057l6.254-6.202 85.686 86.416-6.255 6.202z"
          />
          <path
            data-name="Rectangle 1267"
            fill="#0b0b3a"
            d="M321.954 215.88l6.254-6.202 2.164 2.182-6.255 6.202z"
          />
          <path
            data-name="Path 9338"
            d="M416.037 298.298l-2.372 2.348-85.647-86.453-2.161-2.173-3.9 3.844 6.262-6.2 2.156 2.169z"
            fill="#ffc25b"
          />
          <path
            data-name="Rectangle 1268"
            fill="#0b0b3a"
            d="M408.582 303.299l6.254-6.202 1.21 1.22-6.255 6.201z"
          />
          <path
            data-name="Path 9339"
            d="M401.738 288.38l-3.692-3.073s-1.086 1.8-1.881 2.044a5.726 5.726 0 01-.981-.105 6.425 6.425 0 00-2.979.923c-.865.4-2.009.759-2.056 1.1s.561.9 1.168.853a1.169 1.169 0 00.292 0 1.917 1.917 0 00.07.362c.257.783 3.879 5.841 7.477.339a10.106 10.106 0 012.582-2.442z"
            fill="#ffbc9f"
          />
          <path
            data-name="Path 9340"
            d="M403.595 252.357c1.227 3.75 2.523 9.673 4.977 14.7 0 .117.105.222.152.315v.058a4.2 4.2 0 00.175.561 4.5 4.5 0 004.381 3h2.757a2.113 2.113 0 001.647-.572 1.423 1.423 0 00.093-.374 1.169 1.169 0 000-.21 1.26 1.26 0 000-.222v-.631a2.855 2.855 0 000-.315 20.72 20.72 0 00-.257-3.073c-.385-4.218-4.556-17.431-5.982-22.945a3.726 3.726 0 00-1.3-2.033 3.33 3.33 0 00-1.974-.783h-.339c-1.858 0-3.119 1.507-3.972 3.248a11.3 11.3 0 00-1.1 3.657 13.108 13.108 0 00.742 5.619z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9341"
            d="M397.076 286.627l2.488 2.512.6.526s4.673-4.066 8.33-7.5c3.376-3.2 6.811-6.776 8.949-11.052a5.858 5.858 0 00.292-.608 1.427 1.427 0 00.093-.374 1.172 1.172 0 000-.21 1.26 1.26 0 000-.222v-.631a2.847 2.847 0 000-.315 3.832 3.832 0 00-.853-2.465l-.175-.2a4 4 0 00-.911-.666 4.857 4.857 0 00-.689-.292 6.5 6.5 0 00-5.222.713l-.444.467a13.19 13.19 0 00-.97 1.168 18.982 18.982 0 00-2.512 4.206c-2.071 5.095-8.976 14.943-8.976 14.943z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9342"
            d="M342.307 236.38s-5.619-3.914-5.841-6.9c-.28-3.306 2.044-4.9 3.5-3.073 2.407 2.862 1.764 8.049 1.764 8.049l.537 1.928z"
            fill="#ffd4c5"
          />
          <path
            data-name="Rectangle 1269"
            fill="#ffdc8f"
            d="M454.602 193.526h13.868v16.122h-13.868z"
          />
          <path
            data-name="Path 9343"
            d="M462.523 195.187a.97.97 0 11-.958-.958.97.97 0 01.958.958z"
            fill="#ff8736"
          />
          <path
            data-name="Rectangle 1270"
            fill="#ffdc8f"
            d="M474.615 188.094h13.868v16.122h-13.868z"
          />
          <path
            data-name="Path 9344"
            d="M482.501 189.753a.97.97 0 11-.97-.97.97.97 0 01.97.97z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9345"
            d="M309.782 191.19s-5.456-8.867-1.168-9.638 1.939 8.33 1.168 9.638z"
            fill="#fff"
          />
          <path
            data-name="Path 9346"
            d="M311.114 191.19s1.869-6.18 4.393-3.575-4.393 3.575-4.393 3.575z"
            fill="#fff"
          />
          <path
            data-name="Path 9347"
            d="M462.52 100.73s-1.168 44.009 35.843 48.1c7.2.7 20.4.362 19.475-10.141-.479-5.538-5.059-11.963-10.316-13.9-4.545-1.682-9.346-2.757-13.786-4.673a11.472 11.472 0 01-5.713-4.439c-2.337-4.007-1.285-9.346-2.979-13.622a23.844 23.844 0 00-8.424-10.758c-5.432-3.832-12.255-3.855-13.8 3.715a32.058 32.058 0 00-.3 5.713z"
            fill="#c3ecfe"
            opacity={0.35}
          />
          <path
            data-name="Path 9348"
            d="M162.917 60.927c-.958.783-2.021 1.46-3.049 2.161-11.075 7.547-20.947 20.094-21.485 33.962-.7 17.758-27.2.759-20.141-24.592s29.499-25.364 35.618-24.546c3.622.479 10.515 2.161 11.881 6.169a5.713 5.713 0 01-1.344 5.386 10.865 10.865 0 01-1.48 1.46z"
            fill="#c3ecfe"
            opacity={0.35}
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
